export type DomainErrorCode = 'validation' | 'calculation' | 'serialization';

export class DomainError extends Error {
  readonly code: DomainErrorCode;
  readonly details: Record<string, unknown> | undefined;

  constructor(
    code: DomainErrorCode,
    message: string,
    details?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'DomainError';
    this.code = code;
    this.details = details;
  }

  static validation(
    message: string,
    details?: Record<string, unknown>,
  ): DomainError {
    return new DomainError('validation', message, details);
  }

  static calculation(
    message: string,
    details?: Record<string, unknown>,
  ): DomainError {
    return new DomainError('calculation', message, details);
  }

  static serialization(
    message: string,
    details?: Record<string, unknown>,
  ): DomainError {
    return new DomainError('serialization', message, details);
  }
}